$(function() {
  $('.ws--course--box').on('click', function(){
    window.location = $(this).find('a').attr('href');
  });
});
